import { Content, Overlay, Portal, Root } from "@radix-ui/react-dialog";
import styles from "./styles.module.css";
import { ReactComponent as HomeSvg } from "../../../assets/navbericon/home.svg";
import { ReactComponent as OrdersSvg } from "../../../assets/navbericon/orders.svg";
import { ReactComponent as CartSvg } from "../../../assets/navbericon/cart.svg";
import { ReactComponent as UsersSvg } from "../../../assets/navbericon/users.svg";
import { ReactComponent as TicketsSvg } from "../../../assets/navbericon/mail.svg";
import { ReactComponent as ShippingSvg } from "../../../assets/navbericon/recycle.svg";
import { ReactComponent as SettingsSvg } from "../../../assets/navbericon/settings.svg";
import { ReactComponent as TermsSvg } from "../../../assets/navbericon/terms.svg";
import { ReactComponent as Logo } from "../../../assets/altlogo.svg";
import { ReactComponent as LogOutSvg } from "../../../assets/navbericon/icon/logout.svg";
import useMediaQuery from "../../../app/common/hooks/useMediaQuery";
import NavLinkItem from "./NavLinkItem";
import { useNavigate } from "react-router-dom";
import { useStore } from "../../../app/stores/store";
import { UserPermissions } from "../../../app/models/user";

interface SideBarProps {
  open: boolean;
  setOpen: (state: boolean) => void;
  //   baseUrl: "admin" | "super-admin";
}

const SideBar = ({ open, setOpen }: SideBarProps) => {
  const matches = useMediaQuery("(min-width: 1290px)");
  const navigate = useNavigate();
  const { userStore, commonStore } = useStore();
  const { isAuthorized } = commonStore;
  const { logout } = userStore;
  return (
    <>
      {!matches ? (
        <Root open={open} onOpenChange={setOpen}>
          <Portal>
            <Overlay className={"overlay"} />
            <Content className={"sideBarContainer"}>
              <div className={styles.logoSm}>
                <Logo onClick={() => navigate("/")} />
              </div>
              <div className={styles.navLinksContainer}>
                <NavLinkItem
                  marginMd
                  to={`/vendor/dashboard`}
                  heading="Dashboard"
                >
                  <HomeSvg />
                </NavLinkItem>
                <div className="divider" />
                {isAuthorized(UserPermissions.viewOrders) && (
                  <NavLinkItem marginMd to={`/vendor/orders`} heading="Orders">
                    <OrdersSvg />
                  </NavLinkItem>
                )}
                <div className="divider" />
                {isAuthorized(UserPermissions.addProducts) && (
                  <NavLinkItem
                    marginMd
                    to={`/vendor/products`}
                    heading="Products"
                  >
                    <CartSvg />
                  </NavLinkItem>
                )}
                <div className="divider" />
                {isAuthorized(UserPermissions.addUsers) && (
                  <NavLinkItem marginMd to={`/vendor/users`} heading="Users">
                    <UsersSvg />
                  </NavLinkItem>
                )}
                <div className="divider" />
                {isAuthorized(UserPermissions.tickets) && (
                  <NavLinkItem
                    marginMd
                    to={`/vendor/tickets`}
                    heading="Tickets"
                  >
                    <TicketsSvg />
                  </NavLinkItem>
                )}
                <div className="divider" />
                {isAuthorized(UserPermissions.shipping) && (
                  <NavLinkItem
                    marginMd
                    to={`/vendor/shipping`}
                    heading="Shipping"
                  >
                    <ShippingSvg />
                  </NavLinkItem>
                )}
                <div className="divider" />
                {isAuthorized(UserPermissions.settings) && (
                  <NavLinkItem
                    marginMd
                    to={`/vendor/settings`}
                    heading="Settings"
                  >
                    <SettingsSvg />
                  </NavLinkItem>
                )}
                <div className="divider" />

                <NavLinkItem
                  marginMd
                  to={`/vendor/terms`}
                  heading="Terms & Conditions"
                >
                  <TermsSvg />
                </NavLinkItem>
                <div className="divider" />
                <button className={styles.navLogout} onClick={() => logout()}>
                  <LogOutSvg />
                  <p>Logout</p>
                </button>
              </div>
            </Content>
          </Portal>
        </Root>
      ) : (
        <div className={styles.sideBarContainer}>
          <div className={styles.sidebarInner}>
            {/* <img
              src={logo}
              style={{ cursor: "pointer" }}
              onClick={() => navigate("/")}
              alt=""
            /> */}
            <Logo onClick={() => navigate("/")} style={{cursor:"pointer"}}/>
            <div className={styles.navLinksContainer}>
              <NavLinkItem to={`/vendor/dashboard`} heading="Dashboard">
                <HomeSvg />
              </NavLinkItem>
              {isAuthorized(UserPermissions.viewOrders) && (
                <NavLinkItem to={`/vendor/orders`} heading="Orders">
                  <OrdersSvg />
                </NavLinkItem>
              )}
              {isAuthorized(UserPermissions.addProducts) && (
                <NavLinkItem to={`/vendor/products`} heading="Products">
                  <CartSvg />
                </NavLinkItem>
              )}
              {isAuthorized(UserPermissions.addUsers) && (
                <NavLinkItem to={`/vendor/users`} heading="Users">
                  <UsersSvg />
                </NavLinkItem>
              )}
              {isAuthorized(UserPermissions.tickets) && (
                <NavLinkItem to={`/vendor/tickets`} heading="Tickets">
                  <TicketsSvg />
                </NavLinkItem>
              )}
              {isAuthorized(UserPermissions.shipping) && (
                <NavLinkItem to={`/vendor/shipping`} heading="Shipping">
                  <ShippingSvg />
                </NavLinkItem>
              )}
              {isAuthorized(UserPermissions.settings) && (
                <NavLinkItem to={`/vendor/settings`} heading="Settings">
                  <SettingsSvg />
                </NavLinkItem>
              )}
              <NavLinkItem to={`/vendor/terms`} heading="Terms & Conditions">
                <TermsSvg />
              </NavLinkItem>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SideBar;
